/* @flow */
import _ from "lodash";
import urlTemplateLib from "url-template";

import { SessionStore } from "../uidispatcherapi/SessionStore";
import { generateUuid } from "./util";

import { REQUEST_PRIORITY } from "./PriorityUtil";

function buildPath(pathParts: Array<any>): string {
    return _.map(pathParts)
        .map((part) => {
            return encodeURIComponent(part);
        })
        .join("/");
}

function getTimestampForQueryAsObject() {
    return { __t: new Date().getTime() };
}

function buildQuery(query: { [x: string]: any }): string {
    return _.keys(query)
        .map((key) => {
            const value = query[key];
            if (value === undefined || value === null) {
                return null;
            }
            if (_.isArray(value)) {
                if (value.length === 0) {
                    return null;
                }
                return _.map(value, (item) => {
                    if (item) {
                        return key + "=" + encodeURIComponent(item);
                    } else {
                        return "";
                    }
                }).join("&");
            }
            return key + "=" + encodeURIComponent(value);
        })
        .filter((entry) => entry !== null)
        .join("&");
}

function buildRequest(
    vertical: string,
    service: string,
    version: string | undefined | null,
    template: string,
    pathParams: {
        [x: string]: string | number;
    },
    queryParams:
        | {
              [x: string]: any;
          }
        | undefined
        | null,
    manualBaseUrl: string | null
) {
    let baseUrl = "".concat("/", vertical, ".", service);
    if (version && version.length > 0) {
        baseUrl = baseUrl.concat(".", version);
    }
    if (manualBaseUrl && manualBaseUrl.length > 0) {
        baseUrl = manualBaseUrl;
    }
    const relativePath = urlTemplateLib.parse(template).expand(pathParams);
    const preQuery = queryParams && buildQuery(queryParams);
    const query = preQuery ? "?" + preQuery : "";
    return "".concat(baseUrl, relativePath, query);
}

/**
 * Tries to get the CallTreeId and client session id from the SessionStore.
 * Otherwise generates its own.
 */
function generateSessionedUuid(): string {
    if (SessionStore.generateSessionedCallTreeIdWithPrefix) {
        return SessionStore.generateSessionedCallTreeIdWithPrefix("BTEX");
    } else {
        return "BTEX-" + generateUuid();
    }
}

function makeCallTreeHeader(): {
    [x: string]: string;
} {
    return { CallTreeId: generateSessionedUuid() };
}

function makeCallTreeHeaderWithPriority(priority: REQUEST_PRIORITY): {
    [x: string]: string;
} {
    return _.assign({}, makeCallTreeHeader(), makePriorityHeader(priority));
}

function makePriorityHeader(priority: REQUEST_PRIORITY): {
    [x: string]: string;
} {
    return { "x-qos-priority": priority };
}

export {
    buildPath,
    getTimestampForQueryAsObject,
    buildQuery,
    buildRequest,
    generateSessionedUuid,
    makeCallTreeHeader,
    makeCallTreeHeaderWithPriority,
    makePriorityHeader
};
